import { connect } from 'react-redux'
import searchAutocompleteView from './SearchAutocomplete.component'
import { addAdministrativeAreas } from '../../../../../actions/searchBar'

const mapStateToProps = (state) => {
  return {
    administrative_areas: state.searchBar.administrative_areas,
    administrative_areas_selected: state.searchBar.administrative_areas_selected,
    loading: state.neighborhood.loading,
    all_administrative_areas: state.searchBar.all_administrative_areas
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onChangeSelection: val => dispatch(addAdministrativeAreas(val))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(searchAutocompleteView)



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/SearchAutoComplete/SearchAutocomplete.container.js